module.exports = __webpack_public_path__ + "img/ic_star_full.63ca4946.svg";